import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { map } from "rxjs/operators";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";

interface IServerResponse {
  status: any;
  message: string;
  result: any;
  count?: number;
  page?: number;
  totalPages?: number;
}

const API_URL = environment.API_URL + "/admin";

@Injectable()
export class GfireService {
  admin_data: any = JSON.parse(localStorage.getItem("user"));

  constructor(private https: Http) {}

  getComplexes(
    page: number = 1,
    limit: number = 15,
    search: string = "",
    status: string = ""
  ): Observable<IServerResponse> {
    let query = `?page=${page}&limit=${limit}`;
    if (search && search.trim() !== "") {
      query += `&search=${encodeURIComponent(search.trim())}`;
    }
    if (status && status.trim() !== "") {
      query += `&status=${encodeURIComponent(status.trim())}`;
    }
    return this.https
      .get(API_URL + "/gfire/complexes" + query)
      .pipe(map((res) => res.json()));
  }

  getComplexById(id: string): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/gfire/complex/get-by-id?id=" + encodeURIComponent(id))
      .pipe(map((res) => res.json()));
  }

  approveOrDenyComplex(payload: any): Observable<IServerResponse> {
    payload.admin_id =
      this.admin_data && this.admin_data._id ? this.admin_data._id : "";
    return this.https
      .post(API_URL + "/gfire/complex/approve-deny", payload)
      .pipe(map((res) => res.json()));
  }

  getPlans(
    page: number = 1,
    limit: number = 50,
    status: string = ""
  ): Observable<IServerResponse> {
    let query = `?page=${page}&limit=${limit}`;
    if (status && status.trim() !== "") {
      query += `&status=${encodeURIComponent(status.trim())}`;
    }
    return this.https
      .get(API_URL + "/gfire/plans" + query)
      .pipe(map((res) => res.json()));
  }

  getPlanById(id: string): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/gfire/plan/get-by-id?id=" + encodeURIComponent(id))
      .pipe(map((res) => res.json()));
  }

  createPlan(payload: any): Observable<IServerResponse> {
    payload.admin_id =
      this.admin_data && this.admin_data._id ? this.admin_data._id : "";
    return this.https
      .post(API_URL + "/gfire/plan/create", payload)
      .pipe(map((res) => res.json()));
  }

  updatePlan(payload: any): Observable<IServerResponse> {
    payload.admin_id =
      this.admin_data && this.admin_data._id ? this.admin_data._id : "";
    return this.https
      .post(API_URL + "/gfire/plan/update", payload)
      .pipe(map((res) => res.json()));
  }

  getShops(params: {
    page?: number;
    limit?: number;
    search?: string;
    complex_id?: string;
    individual_shop?: boolean;
    plan_status?: string;
  } = {}): Observable<IServerResponse> {
    const page = params.page || 1;
    const limit = params.limit || 15;
    let query = `?page=${page}&limit=${limit}`;
    if (params.search && params.search.trim() !== "") {
      query += `&search=${encodeURIComponent(params.search.trim())}`;
    }
    if (params.complex_id && params.complex_id.trim() !== "") {
      query += `&complex_id=${encodeURIComponent(params.complex_id.trim())}`;
    }
    if (params.individual_shop) {
      query += `&individual_shop=true`;
    }
    if (params.plan_status && params.plan_status.trim() !== "") {
      query += `&plan_status=${encodeURIComponent(params.plan_status.trim())}`;
    }
    return this.https
      .get(API_URL + "/gfire/shops" + query)
      .pipe(map((res) => res.json()));
  }

  getShopById(id: string): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/gfire/shop/get-by-id?id=" + encodeURIComponent(id))
      .pipe(map((res) => res.json()));
  }

  getShopSenders(params: {
    shop_id: string;
    page?: number;
    limit?: number;
    search?: string;
  }): Observable<IServerResponse> {
    const page = params.page || 1;
    const limit = params.limit || 15;
    let query =
      `?shop_id=${encodeURIComponent(params.shop_id)}` +
      `&page=${page}&limit=${limit}`;
    if (params.search && params.search.trim() !== "") {
      query += `&search=${encodeURIComponent(params.search.trim())}`;
    }
    return this.https
      .get(API_URL + "/gfire/shop/senders" + query)
      .pipe(map((res) => res.json()));
  }

  removeShopSender(sender_id: string, shop_id?: string): Observable<IServerResponse> {
    const admin_data: any = JSON.parse(localStorage.getItem("user"));
    const body: any = {
      sender_id,
      admin_id: admin_data && admin_data._id ? admin_data._id : "",
    };
    if (shop_id) {
      body.shop_id = shop_id;
    }
    return this.https
      .post(API_URL + "/gfire/shop/remove-sender", body)
      .pipe(map((res) => res.json()));
  }

  getSenderById(id: string): Observable<IServerResponse> {
    return this.https
      .get(API_URL + "/gfire/sender/get-by-id?id=" + encodeURIComponent(id))
      .pipe(map((res) => res.json()));
  }

  getAdmins(
    role: string,
    page: number = 1,
    limit: number = 15,
    search: string = ""
  ): Observable<IServerResponse> {
    let query = `?role=${encodeURIComponent(role)}&page=${page}&limit=${limit}`;
    if (search && search.trim() !== "") {
      query += `&search=${encodeURIComponent(search.trim())}`;
    }
    return this.https
      .get(API_URL + "/gfire/admins" + query)
      .pipe(map((res) => res.json()));
  }

  depromoteAdmin(user_id: string): Observable<IServerResponse> {
    const admin_data: any = JSON.parse(localStorage.getItem("user"));
    return this.https
      .post(API_URL + "/gfire/admin/depromote", {
        user_id,
        admin_id: admin_data && admin_data._id ? admin_data._id : "",
      })
      .pipe(map((res) => res.json()));
  }
}
